import React, { useEffect, useRef, useState } from 'react';
import HeroSection from './components/HeroSection';
import IgniteSection from './components/IgniteSection';
import MarketingSection from './components/MarketingSection';
import BrandsSection from './components/BrandsSection';
import ServicesSection from './components/ServicesSection';
import PartnersSection from './components/PartnersSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

// If video is in /public folder, use "/OMO_Website_Introduction_Video.mp4"
import introVideo from './assets/OMO_Website_Introduction_Video.mp4';

function App() {
  const [showVideo, setShowVideo] = useState(true);
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play().catch(err => console.log("Autoplay blocked:", err));

      // Hide video after 2 seconds
      const timer = setTimeout(() => setShowVideo(false), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div className="app-root">
      {showVideo ? (
        <video
          ref={videoRef}
          src={introVideo}
          autoPlay
          muted
          playsInline
          preload="auto"
          style={{
            width: "100%",
            height: "100vh",
            objectFit: "cover",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 9999
          }}
        />
      ) : (
        <>
          <HeroSection />
          <IgniteSection />
          <MarketingSection />
          <BrandsSection />
          <ServicesSection />
          <PartnersSection />
          <ContactSection />
          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
